import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueByField',
})
export class ValueByFieldPipe implements PipeTransform {
  transform(arrayOfItems: any[], searchKey: string, searchValue, returnKey: string): any {
    try {
      let temp = arrayOfItems.find((item) => item[searchKey] === searchValue);
      return temp ? temp[returnKey] : '';
    } catch (e) {
      return '';
    }
  }
}
